export default {
  namespaced: true,

  getters: {
    enabled(state, getters, rootState, rootGetters) {
      if (!rootGetters['builder/field/enabled']) {
        return false;
      }

      return !!rootGetters['builder/config'].entities.fields
        .name_plural;
    },

    required(state, getters) {
      return getters.enabled;
    },
  },
};
